module.exports = __webpack_public_path__ + "img/banner2_tc.bf508c23.png";